export default "__VITE_ASSET__DKvbaM1c__"